import React from "react";
import { Ban, Download } from "lucide-react";

const btn = "h-9 px-3 rounded-md border bg-card text-sm flex items-center gap-1.5 transition-colors";

export const BulkActionBar = ({ count, canWrite, onExport, onCancel, onClear }) => {
  if (count === 0) return null;
  return (
    <div data-testid="bulk-action-bar" className="flex flex-wrap items-center gap-2 mb-4 rounded-lg border border-accent/30 bg-accent/5 px-4 py-2.5">
      <span className="text-sm font-medium">{count} selected</span>
      <div className="flex-1" />
      <button data-testid="bulk-export" onClick={onExport} className={`${btn} border-input hover:bg-muted`}><Download size={14} /> Export CSV</button>
      {canWrite && (
        <button data-testid="bulk-cancel" onClick={onCancel} className={`${btn} border-destructive/30 text-destructive hover:bg-destructive/10`}><Ban size={14} /> Cancel selected</button>
      )}
      <button data-testid="bulk-clear" onClick={onClear} className={`${btn} border-input hover:bg-muted`}>Clear</button>
    </div>
  );
};
